import { ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TarefasInadimplenciaService extends FgiBackEndService<any> {

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/tarefas/inadimplencia';
  }

  verificarInadimplenciaBeneficiario(cpfOuCnpjBeneficiario: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    const url = `${this.BASE_URL}/beneficiario/${cpfOuCnpjBeneficiario}`;
    return this.http.get(url, { headers}) as Observable<any>;
  }

  verificarInadimplenciaBeneficiarioNoFgiTradicional(cpfOuCnpjBeneficiario: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    const url = `${this.BASE_URL}/beneficiario/${cpfOuCnpjBeneficiario}/fgi`;
    return this.http.get(url, { headers}) as Observable<any>;
  }

  verificarInadimplenciaAgenteFinanceiro(cnpjAgente: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    const url = `${this.BASE_URL}/agente-financeiro/${cnpjAgente}`;
    return this.http.get(url, { headers}) as Observable<any>;
  }

  verificarInadimplenciaAgenteFinanceiroNoFgiTradicional(cnpjAgente: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    const url = `${this.BASE_URL}/agente-financeiro/${cnpjAgente}/fgi`;
    return this.http.get(url, { headers}) as Observable<any>;
  }
}